import React, { FC } from 'react'
import { SubText, TitleH2 } from 'components/Common/Typography'
import { Col, Container, Row } from 'react-bootstrap'
import Image from 'next/image'

const SecondSec: FC<{ data }> = ({ data }) => {
  return (
    <section className="pt-120px pb-120px">
      <Container>
        <Row className="md-reverse align-items-center">
          <Col lg={6} className="d-flex">
            <Image
              src={`/assets/images/technology/${data?.img}.svg`}
              alt="development"
              className="max-w-100 img-fluid"
              quality={70}
              height={645}
              width={645}
            />
          </Col>
          <Col lg={6} className="mb-4 mb-lg-0">
            <TitleH2 className="mb-4 text_black" text={data?.title} />
            <div className="text_para_large text_black mb-4 fw-600">
              {data?.subTitle}
            </div>
            {data?.text?.map((t, i) => {
              return <SubText key={i} className="mb-3 text_black" text={t} />
            })}
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default SecondSec
